import React from 'react';
import {fillSample} from './noticeHelpers';
import './UserNoticePreview.scss';

// Approximate look of the message in the mobile app. The real layout is up to the app.
const UserNoticePreview = props => {
    const {t, title, text, buttonLabel, actionType, completion, phase} = props;
    const blocking = phase === 'BLOCKING';
    const hasAction = actionType && actionType !== 'NONE';
    const primary = buttonLabel
        ? fillSample(buttonLabel)
        : hasAction
            ? t.gettext('Open')
            : completion === 'USER_ACK'
                ? t.gettext('I understand')
                : t.gettext('OK');
    const body = text ? fillSample(text) : t.gettext('Message text appears here');

    return (
        <div className='userNoticePreview'>
            <div className='userNoticePreviewPhone'>
                {!blocking && <div className='userNoticePreviewApp'/>}
                {blocking ? (
                    <div className='userNoticePreviewBlock'>
                        <span className='material-icons userNoticePreviewLock'>lock</span>
                        {title && <div className='userNoticePreviewTitle'>{fillSample(title)}</div>}
                        <div className='userNoticePreviewText'>{body}</div>
                        <div className='userNoticePreviewButton'>{primary}</div>
                        <div className='userNoticePreviewLink'>{t.gettext('Log out')}</div>
                    </div>
                ) : (
                    <div className='userNoticePreviewSheet'>
                        {title && <div className='userNoticePreviewTitle'>{fillSample(title)}</div>}
                        <div className='userNoticePreviewText'>{body}</div>
                        <div className='userNoticePreviewButton'>{primary}</div>
                        <div className='userNoticePreviewLink'>{t.gettext('Close')}</div>
                    </div>
                )}
            </div>
            <div className='userNoticePreviewCaption'>
                {blocking ? t.gettext('Blocked: full screen') : t.gettext('Warning: dialog over the app')}
            </div>
        </div>
    );
};

export default UserNoticePreview;
